
import { createTheme } from '@mui/material/styles';
import { koKR } from '@mui/x-data-grid-pro';
import { koKR as corekoKR } from '@mui/material/locale';



const theme = createTheme(
    {
         breakpoints: {
            values: {
                xs: 0,    // 모바일
                sm: 600,  // 큰 모바일/태블릿
                md: 900,  // 데스크탑 시작 (PMS 권장 기준)
                lg: 1200, // 와이드 화면
                xl: 1536,
            },
        },
        typography: {
            fontFamily: [
                'Noto Sans CJK KR',
            ].join(','),
        },
        palette: {
            default: {
                dark: '#000000',
                light: '#111111',
                main: '#100008',
                contrastText: '#ffffff',
            },

        },

        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    '*': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#B7B7B7 transparent',
                        '&::-webkit-scrollbar': {
                            width: 6,
                            height: 6,
                            backgroundColor: 'transparent',
                        },
                        '&::-webkit-scrollbar-track': {
                            // backgroundColor: 'transparent',
                            borderRadius: 6,
                            background: "rgba(0,0,0,.1)",
                        },
                        '&::-webkit-scrollbar-thumb': {
                            borderRadius: 6,
                            background: "rgba(0,0,0,.2)",
                            // minHeight: 24,
                            // minWidth: 24,
                        },
                        '&::-webkit-scrollbar-thumb:focus': {
                            //backgroundColor: '#adadad',
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-thumb:active': {
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-corner': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },

        },

    },



    koKR,
    corekoKR
);
export default theme